import styled, { css } from 'styled-components';

import { getDefaultBorderColor } from '@mews-ui/theme';
import { SPACING } from '@optimus-web/local-tokens';
import { Stack } from '../Stack';

export const APPBAR_DESKTOP_HEIGHT = 72;
export const APPBAR_MOBILE_HEIGHT = 50;

interface AppbarContainerProps {
    hasRightActions: boolean;
    small?: boolean;
    hasBorder?: boolean;
}

export const AppbarContainer = styled.div<AppbarContainerProps>`
    background: ${({ theme }) => theme.designTokens.BACKGROUND_STATIC_SUNKEN};
    padding: 0 ${({ theme, small }) => (small ? theme.designTokens.SPACING_100 : theme.designTokens.SPACING_400)}px;
    height: ${({ small }) => (small ? APPBAR_MOBILE_HEIGHT : APPBAR_DESKTOP_HEIGHT)}px;

    display: flex;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;

    ${({ hasRightActions, theme }) =>
        hasRightActions &&
        css`
            padding-right: ${theme.designTokens.SPACING_200}px;
        `}

    ${({ hasBorder }) =>
        hasBorder &&
        css`
            border-bottom: 1px solid ${getDefaultBorderColor};
        `}

    > * {
        width: 100%;
    }
`;

export const ActionElementsContainer = styled(Stack)`
    align-items: center;
    align-self: stretch;
    border-left: 1px solid ${getDefaultBorderColor};
    display: flex;
    padding: ${SPACING[200]}px 0 ${SPACING[200]}px ${SPACING[200]}px;
`;

export const AppbarDivider = styled.div`
    width: 1px;
    height: ${({ theme }) => theme.designTokens.SIZING_200}px;
    background: ${({ theme }) => theme.designTokens.BORDER_STATIC_PRIMARY};
`;
